import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { string } from "prop-types";
import DataGrid from '../../../../OurModules/DataGrid/src/index.js';

/**
 * Container component for the pharmacy page.
 * 
 */


const StatusDisplay = ({ status }) => {
    switch (status.toUpperCase()) {
        case "APPROVED":
            return <div id="authorization-detail-status" className="bold-text status-detail-label authorization-approved"><span className="icon-check status-checkmark"></span>{status}</div>;
        case "PARTIALLY APPROVED":
            return <div id="authorization-detail-status" className="bold-text status-detail-label authorization-partially-approved">{status}</div>;
        case "PENDING":
            return <div id="authorization-detail-status" className="bold-text status-detail-label authorization-pending">{status}</div>;
        case "NOT APPROVED":
            return <div id="authorization-detail-status" className="bold-text status-detail-label authorization-not-approved"><span className="icon-error status-icon"></span>{status}</div>;
        default:
            return <div id="authorization-detail-status" className="bold-text status-detail-label"> - </div>
    }
    return "";
}

class AuthorizationDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authorizationHccId: props.location.state.authorizationHccId,
            showLoader: true,
            shouldLoadData: true,
        };

        this.addAuthServicesCSSClass = this.addAuthServicesCSSClass.bind(this);
        this.addFirstNameProp = this.addFirstNameProp.bind(this);
        this.assignAuthServicesStatusCSS = this.assignAuthServicesStatusCSS.bind(this);
        this.printAuthDetails = this.printAuthDetails.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AuthorizationDetail.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if (this.props.authorizationDetail !== prevProps.authorizationDetail) {
            if (this.props.authorizationDetail) {
                this.addAuthServicesCSSClass(this.props.authorizationDetail);
                this.addFirstNameProp(this.props.authorizationDetail);
                this.setState({ showLoader: false });
            }
        }

        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            this.props.getAuthorizationDetail(this.state.authorizationHccId);
            this.setState({ shouldLoadData: false });
        }
    }

    goBack() {
        this.props.history.goBack();
    }

    printAuthDetails() {
        var menu = document.getElementsByClassName('menu')[0];
        var menuListItems = menu.getElementsByClassName('menu-list')[0];

        //inject class to hide side bar class
        menuListItems.classList.add("hide-side-bar");

        window.print();

        //once print window closes, remove hide side class
        menuListItems.classList.remove("hide-side-bar");
    }

    addAuthServicesCSSClass(authDetail) {
        authDetail.serviceSets.map((service) => {
            return service.statusClass = this.assignAuthServicesStatusCSS(service.statusName);
        });
    }

    addFirstNameProp(authDetail) {
        if (authDetail.patientName) {
            console.log(authDetail.patientName);
            //assuming "lastname, firstname" format, which is how it's returned from HR 
            const names = authDetail.patientName.trim().split(',');
            const fName = names[1].trim().split(' '); //just in case there's a middle initial, exclude it
            return authDetail.firstName = fName[0];
        }
        else {
            return authDetail.firstName = "";
        }
    }

    assignAuthServicesStatusCSS(status) {
        switch (status.toUpperCase()) {
            case "APPROVED":
                return "authorization-approved";
            case "PARTIALLY APPROVED":
                return "authorization-partially-approved";
            case "PENDING":
                return "authorization-pending";
            case "NOT APPROVED":
                return "authorization-not-approved";
            default:
                return "";
        }
    }

    render() {
        var columnMetadata = [
            {
                type: "string",
                title: "Service Code",
                value: "serviceCode",
                allowSorting: false
            },
            {
                type: "string",
                title: "Description",
                value: "shortDesc",
                allowSorting: false
            },
            {
                type: "string",
                title: "Service Provider",
                value: "providerName",
                allowSorting: false
            },
            {
                type: "string",
                title: "Unit/Days",
                value: "unitCount",
                allowSorting: false,
            },
            {
                type: "date",
                title: "Date",
                value: "startDate",
                allowSorting: false
            },
            {
                type: "string",
                title: "Status",
                value: "statusName",
                allowSorting: false,
                customCSSMapToValue: "statusClass"
            },
        ]
        var gridMetadata = {
            title: "",
            selectable: false,
            enableFilters: false,
            filters: [],
            searchFields: [],
            searchPlaceholder: "",
            enableExport: false,
            enableSearch: false,
            enableDateRange: false, //not implemented
            exportFormats: [],
            exportName: "",
            sortingEnabled: false,
            pagination: false, //not implemented
            rowsPerPage: 0, //not implemented
            rowClick: "",
            columns: columnMetadata
        }

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="authorization-wrapper">
                            {this.state.showLoader ?
                                <div id="authorization-detail-spinner" className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div>
                                :
                                <div className="authorization-container">
                                    <div className="row">
                                        <span className="link-text cursor-pointer" onClick={() => this.goBack()}>{'< Back'}</span>
                                    </div>

                                    <div className="hp-title">
                                        Authorization Details
                                    </div>

                                    <hr></hr>

                                    <div className="row authorization-base-detail">
                                        <div className="col-12 col-sm-6">
                                            <span id="authorization-detail-patient-name" className="bold-text authorization-base-label">Member:</span> {this.props.authorizationDetail.firstName ? this.props.authorizationDetail.firstName : ""}
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="semi-bold-text control-item" onClick={() => this.printAuthDetails()}>
                                                <span id="authorization-detail-print" className="link-text cursor-pointer"><span className="icon-print control-icon"></span><span> Print</span></span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <span id="authorization-detail-start-date" className="bold-text authorization-base-label">Date of Service:</span> {moment(this.props.authorizationDetail.startDate).format("MM/DD/YYYY")}
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <span id="authorization-detail-authorization-hcc-id" className="bold-text authorization-base-label">Number:</span>{this.props.authorizationDetail.authorizationHccId}
                                        </div>
                                    </div>

                                    <hr></hr>

                                    <div className="row authorization-status-detail">
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text authorization-label">Status</div>
                                                <StatusDisplay status={this.props.authorizationDetail.authorizationStatusName} />
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text authorization-label">Alternate Auth Number</div>
                                                <div id="authorization-detail-external-authorization-num" className="status-detail-label">{this.props.authorizationDetail.externalAuthorizationNum && this.props.authorizationDetail.externalAuthorizationNum.trim() === "" ? "-" : this.props.authorizationDetail.externalAuthorizationNum}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text authorization-label">Referrer</div>
                                                <div id="authorization-detail-referring-provider-name" className="status-detail-label">{this.props.authorizationDetail.referringProviderName && this.props.authorizationDetail.referringProviderName.trim() === "" ? "-" : this.props.authorizationDetail.referringProviderName}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text authorization-label">Type</div>
                                                <div id="authorization-detail-authorization-type" className="status-detail-label">{this.props.authorizationDetail.authorizationType && this.props.authorizationDetail.authorizationType.trim() === "" ? "-" : this.props.authorizationDetail.authorizationType}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text authorization-label">Admission Type</div>
                                                <div id="authorization-detail-admission-type" className="status-detail-label">{this.props.authorizationDetail.admissionType && this.props.authorizationDetail.admissionType.trim() == "" ? "-" : this.props.authorizationDetail.admissionType}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text authorization-label">Approval Letter</div>
                                                <div id="authorization-detail-document-is-available" className="status-detail-label">{this.props.authorizationDetail.documentIsAvailable ? <span>Available</span> : <span>Unavailable</span>}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row card-top">
                                                <div className="col-12 maxWidth-content">
                                                    <DataGrid id="authorization-detail-service-sets" dataSource={this.props.authorizationDetail.serviceSets} gridOptions={gridMetadata} showLoader={this.state.showLoader}></DataGrid>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizationDetail: state.healthPlanServices.authorizationDetail,
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAuthorizationDetail: (authorizationHccId) => dispatch({ type: types.HP_GET_AUTHORIZATION_DETAIL_START, authorizationHccId: authorizationHccId }),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthorizationDetail));
